import { useTheme } from '../theme/theme'

const OPTIONS = ['system', 'light', 'dark'] as const

const LABELS = {
  system: 'System',
  light: 'Light',
  dark: 'Dark',
} as const

export function ThemeToggle() {
  const { preference, setPreference } = useTheme()

  return (
    <div role="radiogroup" aria-label="Color theme" className="flex items-center gap-1">
      {OPTIONS.map(option => {
        const checked = preference === option
        return (
          <button
            key={option}
            type="button"
            role="radio"
            aria-checked={checked}
            onClick={() => setPreference(option)}
            className={`rounded px-2 py-1 text-xs ${checked ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-100'}`}
          >
            {LABELS[option]}
          </button>
        )
      })}
    </div>
  )
}
